<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">クラス登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'class' }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_class.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmAdded)" ref="form">
          <table class="table table-form">
            <tbody>
              <ChoiceField
                v-model="corporationChoiceFieldMultiModels"
                extraRules="required_select"
                label="法人名（法人ID）"
                placeholder="選択してください"
                resourceType="corporation"
                modelFieldName="corporation"
                :choiceDisable="loggedInAsCorporation || loggedInAsBrand || loggedInAsSchool"
                :childFieldNames="childFieldNamesForCorporation"
                :formData="currentTamaiClass"
              />
              <ChoiceField
                v-model="brandChoiceFieldMultiModels"
                extraRules="required_select"
                label="ブランド名（ブランドID）"
                placeholder="選択してください"
                resourceType="brand"
                modelFieldName="brand"
                :choiceDisable="loggedInAsBrand || loggedInAsSchool || isEmpty(currentTamaiClass.corporation)"
                :childFieldNames="childFieldNamesForBrand"
                :formData="currentTamaiClass"
              />
              <ChoiceField
                v-model="schoolChoiceFieldMultiModels"
                extraRules="required_select"
                label="教場名（教場ID）"
                placeholder="選択してください"
                resourceType="school"
                modelFieldName="school"
                :choiceDisable="loggedInAsSchool || isEmpty(currentTamaiClass.brand)"
                :formData="currentTamaiClass"
              />
              <ChoiceField
                v-model="courseChoiceFieldMultiModels"
                extraRules="required_select"
                label="コース名（コースID）"
                placeholder="選択してください"
                resourceType="course"
                modelFieldName="course"
                :choiceDisable="isEmpty(currentTamaiClass.brand)"
                :formData="currentTamaiClass"
              />
              <TextField
                v-model="currentTamaiClass.name"
                extraRules="required"
                label="クラス名"
                placeholder="入力してください"
              />
              <TextField
                v-model="currentTamaiClass.nameReading"
                extraRules="required"
                label="クラス名フリガナ"
                placeholder="入力してください"
              />
              <ChoiceField
                v-model="mainTeacherChoiceFieldModel"
                extraRules="required_select"
                label="先生名（担当・メイン）"
                placeholder="選択してください"
                resourceType="teacher"
                modelFieldName="mainTeacher"
                :choiceDisable="isEmpty(currentTamaiClass.brand)"
                :formData="currentTamaiClass"
                :excludeItems="teacherChose"
              />

              <!-- Note that index is from 1 to 8 -->
              <template v-for="index in maxNumOfTeacher">
                <ChoiceField
                  v-if="index == 1 || currentTamaiClass[teacherKeyAtIndex(index - 1)].id"
                  :key="index"
                  v-model="currentTamaiClass[teacherKeyAtIndex(index)].name"
                  :label="teacherLabelAtIndex(index)"
                  placeholder="選択してください  / サブの先生は最大8名まで登録可能です"
                  resourceType="teacher"
                  :modelFieldName="teacherKeyAtIndex(index)"
                  :choiceDisable="isEmpty(currentTamaiClass.brand)"
                  :formData="currentTamaiClass"
                  :excludeItems="teacherChose"
                >
                  <template v-slot:afterInput>
                    <button
                      type="button"
                      class="btn-sm"
                      :disabled="isEmpty(currentTamaiClass[teacherKeyAtIndex(index)])"
                      @click="releaseTeacher(index)"
                      v-if="currentTamaiClass[teacherKeyAtIndex(index)]"
                    >
                      解除
                    </button>
                  </template>
                </ChoiceField>
              </template>
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import isEmpty from 'lodash/isEmpty';
import EventBus from '@/helpers/EventBus.js';
import TextField from '@/components/forms/TextField.vue';
import ChoiceField from '@/components/forms/ChoiceField.vue';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
} from '@/presenters/fields';

export default {
  data() {
    return {
      currentTamaiClass: {},
    };
  },
  components: {
    ValidationObserver,
    TextField,
    ChoiceField,
  },
  computed: {
    teacherChose() {
      let teacherIds = [];

      if (!isEmpty(this.currentTamaiClass.mainTeacher)) {
        teacherIds.push(this.currentTamaiClass.mainTeacher.id);
      }

      for (let index = 1; index <= this.maxNumOfTeacher; index++) {
        const teacher = this.currentTamaiClass[this.teacherKeyAtIndex(index)];

        if (!isEmpty(teacher)) {
          teacherIds.push(teacher.id);
        }
      }

      return { teacherId: teacherIds };
    },
    corporationChoiceFieldMultiModels() {
      return basicCorporationNameIdPresent(this.currentTamaiClass.corporation);
    },
    brandChoiceFieldMultiModels() {
      return basicBrandNameIdPresent(this.currentTamaiClass.brand);
    },
    schoolChoiceFieldMultiModels() {
      return basicSchoolNameIdPresent(this.currentTamaiClass.school);
    },
    courseChoiceFieldMultiModels() {
      return basicCourseNameIdPresent(this.currentTamaiClass.course);
    },
    mainTeacherChoiceFieldModel() {
      if (this.currentTamaiClass.mainTeacher) {
        return this.currentTamaiClass.mainTeacher.name;
      }
      return '';
    },
    teacherFieldNames() {
      let fieldNames = [];

      for (let i = 1; i <= this.maxNumOfTeacher; i++) {
        fieldNames.push(this.teacherKeyAtIndex(i));
      }

      return fieldNames;
    },
    childFieldNamesForCorporation() {
      return ['brand', 'school', 'course', 'mainTeacher'].concat(this.teacherFieldNames);
    },
    childFieldNamesForBrand() {
      return ['school', 'course', 'mainTeacher'].concat(this.teacherFieldNames);
    },
    ...mapState(['tamai_class']),
    ...mapGetters('tamai_class', ['maxNumOfTeacher']),
    ...mapState('form', ['prevFormData']),
    ...mapState(['corporation']),
    ...mapState(['brand']),
    ...mapState(['school']),
    ...mapGetters('auth', ['loggedInAsCorporation', 'loggedInAsBrand', 'loggedInAsSchool']),
  },
  mounted() {
    EventBus.$on('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  created() {
    this.currentTamaiClass = this.createFreshTamaiClassObject();
  },
  beforeDestroy() {
    EventBus.$off('SET_USER_PROFILE', this.setCurrentRoleHandler);
  },
  methods: {
    createFreshTamaiClassObject() {
      if (this.tamai_class.editingTamaiClass) {
        this.$logger.debug('Editing old Class with ID ' + this.tamai_class.editingTamaiClass);
        return this.tamai_class.editingTamaiClass;
      } else if (this.prevFormData) {
        this.$logger.debug('Restoring previous form data', this.prevFormData);

        // Set default value for teacher[idx]
        for (let i = 1; i <= this.maxNumOfTeacher; i++) {
          if (this.isEmpty(this.prevFormData[this.teacherKeyAtIndex(i)])) {
            this.prevFormData[this.teacherKeyAtIndex(i)] = {};
          }
        }
        return this.prevFormData;
      } else {
        let newTamaiClass = {
          corporation: null,
          brand: null,
          school: null,
          course: null,
          name: '',
          nameReading: '',
          mainTeacher: {},
          teacher1: {},
          teacher2: {},
          teacher3: {},
          teacher4: {},
          teacher5: {},
          teacher6: {},
          teacher7: {},
          teacher8: {},
        };

        if (this.loggedInAsCorporation) {
          newTamaiClass['corporation'] = this.corporation.corporation;
        }
        if (this.loggedInAsBrand) {
          newTamaiClass['brand'] = this.brand.brand;
          newTamaiClass['corporation'] = this.brand.brand.corporation;
        }
        if (this.loggedInAsSchool) {
          newTamaiClass['school'] = this.school.school;
          newTamaiClass['brand'] = this.school.school.brand;
          newTamaiClass['corporation'] = this.school.school.corporation;
        }

        return newTamaiClass;
      }
    },
    releaseTeacher(toIndex) {
      if (toIndex >= 1 && toIndex <= this.maxNumOfTeacher) {
        for (let index = toIndex; index <= this.maxNumOfTeacher; index++) {
          const nextIndex = index + 1;
          const nextTeacherId = this.currentTamaiClass[this.teacherKeyAtIndex(nextIndex)];
          if (nextTeacherId) {
            this.currentTamaiClass[this.teacherKeyAtIndex(index)] = nextTeacherId;
            this.$logger.debug('Swap teacher at index ' + nextIndex + ' to index ' + index);
          } else {
            this.currentTamaiClass[this.teacherKeyAtIndex(index)] = {};
            this.$logger.debug('Release teacher at index ' + index);
            break;
          }
        }
      }
    },
    teacherLabelAtIndex(index) {
      return `先生名（担当・サブ${index})`;
    },
    teacherKeyAtIndex(index) {
      return 'teacher' + index;
    },
    confirmAdded() {
      this.$logger.debug('Started Adding: ' + JSON.stringify(this.currentTamaiClass));
      this.startEditingTamaiClass(this.currentTamaiClass);
      this.$router.push({ name: 'class-confirm' });
    },
    setCurrentRoleHandler(payload) {
      if (this.loggedInAsCorporation) {
        this.currentTamaiClass.corporation = payload.data;
      }

      if (this.loggedInAsBrand) {
        this.currentTamaiClass.brand = payload.data;
        this.currentTamaiClass.corporation = payload.data.corporation;
      }

      if (this.loggedInAsSchool) {
        this.currentTamaiClass.school = payload.data;
        this.currentTamaiClass.brand = payload.data.brand;
        this.currentTamaiClass.corporation = payload.data.corporation;
      }
    },
    ...mapActions('tamai_class', ['startEditingTamaiClass']),
  },
};
</script>
<style scoped>
.btn-confirm {
  margin-left: 0px;
}
.img-inline {
  margin-left: 5px;
}
.line-break {
  width: 100%;
}
.body-td-explain {
  margin-left: 5px;
  font-size: 10px;
}
</style>
